import { useCallback, useEffect, useState } from 'react';
import api from '../services/api';

/**
 * useAiQuota(feature?)
 * Fetches the current user's monthly AI quotas and returns a specific feature's
 * status, or the whole bundle if no feature is passed.
 *
 * Call `reload()` after a successful AI call to refresh counters — the backend
 * only updates the quota row after logging a successful call.
 */
export default function useAiQuota(feature = null) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const load = useCallback(async () => {
        setLoading(true);
        try {
            const { data: resp } = await api.get('/user/ai-quota.php');
            setData(resp.data || null);
            setError(null);
        } catch (err) {
            setError(err.response?.data?.message || 'Erreur');
            setData(null);
        }
        setLoading(false);
    }, []);

    useEffect(() => { load(); }, [load]);

    const quota = feature && data?.quotas ? data.quotas[feature] : null;

    return {
        loading,
        error,
        bypass: !!data?.admin_bypass,
        quotas: data?.quotas || {},
        quota,                    // only when `feature` was provided
        reload: load,
    };
}
